import { render, staticRenderFns } from "./model_page.vue?vue&type=template&id=75f140fc&scoped=true"
import script from "./model_page.vue?vue&type=script&lang=js"
export * from "./model_page.vue?vue&type=script&lang=js"
import style0 from "./model_page.vue?vue&type=style&index=0&id=75f140fc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75f140fc",
  null
  
)

export default component.exports